import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/brand";

export const WhatsFab = () => (
  <motion.a
    data-testid="whatsapp-fab"
    href={waLink("Olá! Vim pelo site e gostaria de atendimento.")}
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp"
    initial={{ scale: 0 }}
    animate={{ scale: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 220, damping: 14 }}
    whileHover={{ scale: 1.08 }}
    className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_12px_40px_rgba(37,211,102,.45)]"
  >
    <span className="pulse-ring absolute inset-0 rounded-full bg-[#25D366]" />
    <MessageCircle className="relative h-7 w-7" />
  </motion.a>
);
